// ===========================
   // START VARIANT CHANGE WITH QTY SUM JS
// ===========================
document.addEventListener('change', function (event) {
  const sizeSelect = event.target;

  if (sizeSelect.matches('.select__select[name="options[Size]"]')) {
    const selectedOption = sizeSelect.options[sizeSelect.selectedIndex];

    // Variant pricing info
    const variantPrice = selectedOption.getAttribute('data-variant-price');
    const variantPPrice = selectedOption.getAttribute('data-variant-pprice');

    // Inputs and display targets
    const quantityInputMain = document.querySelector('.quantity__total__input.quantity__input');
    const quantityInputSum = document.querySelector('.quantity__input.custom-sum-qty');
    const priceSpan = document.querySelector('.custom-each-price-total .totle_price');

    // 1. Update price display
    if (variantPrice && quantityInputMain) {
      const formattedPrice = `${variantPrice}`;
      quantityInputMain.value = formattedPrice;
      quantityInputMain.setAttribute('value', formattedPrice);
    }

    // 2. Update data-pprice on both inputs
    if (variantPPrice) {
      if (quantityInputMain) {
        quantityInputMain.setAttribute('data-pprice', variantPPrice);
      }
      if (quantityInputSum) {
        quantityInputSum.setAttribute('data-pprice', variantPPrice);
      }
    }

    // 3. Update visible span
    if (variantPrice && priceSpan) {
      priceSpan.textContent = `${variantPrice}`;
    }
  }
});
// ===========================
   // END VARIANT CHANGE WITH QTY SUM JS
// ===========================

document.addEventListener("DOMContentLoaded", function () {

  // ===========================
     // START HEADER JS
  // ===========================

    // Handle click on subchild link
    document.addEventListener('click', function (e) {
      const target = e.target.closest('.site-nav__childlist-item .site-nav__child-link.has_subchild');
      if (target) {
        e.preventDefault();
    
        const li = target.closest('li.site-nav__childlist-item');
        if (li) li.classList.add('active_item');
    
        const childlist = target.closest('.site-nav__childlist');
        if (childlist) {
          childlist.classList.add('active_childlist');
          const subchildGrid = target.nextElementSibling;
          if (subchildGrid && subchildGrid.classList.contains('site-nav__subchildlist-grid')) {
            const height = subchildGrid.scrollHeight + 80;
            childlist.style.height = `${height}px`;
          }
        }
      }
    });
    
    // Handle click on back link
    document.querySelectorAll('.back--childlist-grid a').forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();
    
        const li = el.closest('li.site-nav__childlist-item');
        if (li) li.classList.remove('active_item');
    
        const childlist = el.closest('.site-nav__childlist');
        if (childlist) {
          childlist.classList.remove('active_childlist');
          setTimeout(function () {
            const grid = el.closest('.site-nav__childlist-grid');
            if (grid) {
              const height = grid.scrollHeight + 50;
              childlist.style.height = `${height}px`;
            }
          }, 700);
        }
      });
    });
  
  // ===========================
    // END HEADER JS
  // ===========================

  
  // =======================
    // pdp qty*price
  // =======================
  
  // const quantityInput = document.querySelector('.custom-quantity-price-each-wrapper .quantity__input');
  // if (quantityInput) {
  //   const proprice = parseFloat(quantityInput.getAttribute('data-pprice')) || 0;
  //   const MAX_LIMIT = 1000000;
  //   function updateTotal() {
  //   let quantityValue = parseInt(quantityInput.value) || 0;
  //   if (quantityValue > MAX_LIMIT) {
  //     quantityValue = MAX_LIMIT;
  //     quantityInput.value = MAX_LIMIT;
  //   }
  
  //   const totalPrice = quantityValue * proprice;
  
  //   // Use Shopify.formatMoney if available
  //   const formattedPrice = typeof Shopify !== 'undefined' && Shopify.formatMoney ? Shopify.formatMoney(totalPrice, "{{ shop.money_format }}") : `$${(totalPrice / 100).toFixed(2)}`; // fallback
  //   const totalDisplay = document.querySelector(".custom-each-price-total .totle_price");
  //   if (totalDisplay) {
  //     totalDisplay.innerHTML = formattedPrice;
  //   }
  // }
  //   updateTotal();
    
  //   quantityInput.addEventListener('input', updateTotal);
  //   quantityInput.addEventListener('change', updateTotal);
  // } 

  const quantityInput = document.querySelector('.custom-quantity-price-each-wrapper .quantity__input');
  const priceInput = document.querySelector('.quantity__total__input.quantity__input'); // your price field

    if (quantityInput && priceInput) {
      const MAX_LIMIT = 1000000;
    
      function extractNumericValue(priceString) {
        // Remove currency symbols, commas, etc. → "$1,299.00" → 1299.00
        const numeric = priceString.replace(/[^0-9.]/g, '');
        return parseFloat(numeric) || 0;
      }
    
      function updateTotal() {
        const basePrice = extractNumericValue(priceInput.value);
        let quantityValue = parseInt(quantityInput.value) || 0;
    
        if (quantityValue > MAX_LIMIT) {
          quantityValue = MAX_LIMIT;
          quantityInput.value = MAX_LIMIT;
        }
    
        const totalPrice = basePrice * quantityValue;
    
        // Format the result (you can customize currency symbol)
        const formattedPrice = `${totalPrice.toFixed(2)}`;
    
        const totalDisplay = document.querySelector(".custom-each-price-total .totle_price");
        if (totalDisplay) {
          totalDisplay.textContent =  '$' + formattedPrice;
        }
      }
    
      // Initial total on page load
      updateTotal();
    
      // Recalculate on input/change
      quantityInput.addEventListener('input', updateTotal);
      quantityInput.addEventListener('change', updateTotal);
    }
      
  // =======================
     // pdp qty*price end here
  // =======================

  
  // =======================
     // collection description first pera js start here
  // =======================
    const topContainer = document.querySelector(".custom-collection-description");
    const bottomContainer = document.querySelector(".collection-bottom-description");

    if (topContainer && bottomContainer) {
      const originalHTML = topContainer.innerHTML;

      // Extract <h1>
      const h1Match = originalHTML.match(/<h1[^>]*>[\s\S]*?<\/h1>/i);
      const h1HTML = h1Match ? h1Match[0] : '';

      // Extract first <p>
      const pMatch = originalHTML.match(/<p[^>]*>[\s\S]*?<\/p>/i);
      const fullPHTML = pMatch ? pMatch[0] : '';
      const pContent = pMatch ? pMatch[0].replace(/<\/?p[^>]*>/g, '') : '';

      // Split the <p> content at first <br>
      const splitIndex = pContent.indexOf('<br');
      const firstParagraph = splitIndex !== -1 ? pContent.slice(0, splitIndex) : pContent;
      const remainingParagraph = splitIndex !== -1 ? pContent.slice(splitIndex) : '';

      // Remove <h1> and original <p> from originalHTML to get the "rest"
      let remainingHTML = originalHTML;
      if (h1Match) remainingHTML = remainingHTML.replace(h1Match[0], '');
      if (pMatch) remainingHTML = remainingHTML.replace(pMatch[0], '');

      // Build top container content
      topContainer.innerHTML = '';
      if (h1HTML) topContainer.innerHTML += h1HTML;
      if (firstParagraph) topContainer.innerHTML += `<p>${firstParagraph}</p>`;

      // Build bottom container content: remaining <p> + rest of original HTML
      let bottomHTML = '';
      if (remainingParagraph) bottomHTML += `<p>${remainingParagraph}</p>`;
      bottomHTML += remainingHTML;

      bottomContainer.innerHTML = bottomHTML.trim();
    }
});